import React from 'react';
import type { InstructionSection } from '../../types/developers';
import { InlineText } from './inline';
import { pageTitle } from './ui';

// /developers/rules: McpController::INSTRUCTIONS as parsed by McpInstructions —
// exactly what the AI is told, not a hand-written summary of it.
const RulesTopic: React.FC<{ sections: InstructionSection[] }> = ({ sections }) => (
  <>
    <h1 className={pageTitle}>它会守的规则</h1>
    <p className="mt-1.5 text-[15px] text-gray-700">这几条 AI 绕不过去，撞上了会告诉你，而不是偷偷绕开。</p>
    <div className="mt-5 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <p className="flex items-center gap-2 text-xs text-gray-500">
        <span className="h-1.5 w-1.5 flex-none rounded-full bg-green-600" />
        服务端在接上时发给 AI 的原文。页面直接读同一份 —— 这里写的，就是 AI 实际被告知的。
      </p>
      {sections.map((section) => (
        <div key={section.heading}>
          <h2 className="mb-1 mt-3.5 text-sm font-semibold text-gray-900">{section.heading}</h2>
          <ul className="list-disc space-y-1 pl-5 text-sm text-gray-700">
            {section.items.map((item, i) => (
              <li key={i}>
                <InlineText text={item} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </>
);

export default RulesTopic;
